<template>
    <div class="testimonials__star-wrapper">
        <div
            v-if="stars <= 5"
            class="testimonials__star--active-wrapper"
        >
            <svg
                v-for="i in Math.floor(stars)"
                :key="i"
                class="testimonials__star testimonials__star--active"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                viewBox="0 0 40 38"
            >
                <path
                    d="M20.189,0.110 L26.212,12.298 C26.242,12.358 26.299,12.399 26.365,12.409 L39.832,14.363 C39.999,14.388 40.065,14.592 39.945,14.709 L30.200,24.196 C30.152,24.243 30.130,24.310 30.141,24.376 L32.442,37.772 C32.470,37.938 32.296,38.064 32.147,37.986 L20.102,31.661 C20.043,31.630 19.972,31.630 19.913,31.661 L7.867,37.986 C7.719,38.064 7.545,37.938 7.573,37.772 L9.874,24.376 C9.885,24.310 9.863,24.243 9.815,24.196 L0.070,14.709 C-0.050,14.592 0.016,14.388 0.182,14.363 L13.650,12.409 C13.716,12.399 13.773,12.358 13.803,12.298 L19.826,0.110 C19.900,-0.041 20.115,-0.041 20.189,0.110 Z"/>
            </svg>

            <svg
                v-if="stars % 1 === 0.5"
                class="testimonials__star testimonials__star--active"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 31 30"
            >
                <path
                    d="M15.5,0v24.6c-0.1,0-0.3,0-0.4,0.1l-8.1,5.1C6.9,29.9,6.8,30,6.7,30H6.5c-0.5,0-1-0.6-0.8-1.2L8,19.6c0.1-0.4,0-0.7-0.3-1l-7.3-6.2C0.1,12.2,0,11.9,0,11.7c0-0.5,0.3-0.9,0.8-1l9.5-0.6c0.4,0,0.7-0.3,0.8-0.6l3.5-8.9C14.8,0.2,15.1,0,15.5,0L15.5,0z"
                />
            </svg>
        </div>

        <div
            v-else
            class="testimonials__star--active-wrapper"
        >
            <svg
                v-for="i in 5"
                :key="i"
                class="testimonials__star testimonials__star--active"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                viewBox="0 0 40 38"
            >
                <path
                    d="M20.189,0.110 L26.212,12.298 C26.242,12.358 26.299,12.399 26.365,12.409 L39.832,14.363 C39.999,14.388 40.065,14.592 39.945,14.709 L30.200,24.196 C30.152,24.243 30.130,24.310 30.141,24.376 L32.442,37.772 C32.470,37.938 32.296,38.064 32.147,37.986 L20.102,31.661 C20.043,31.630 19.972,31.630 19.913,31.661 L7.867,37.986 C7.719,38.064 7.545,37.938 7.573,37.772 L9.874,24.376 C9.885,24.310 9.863,24.243 9.815,24.196 L0.070,14.709 C-0.050,14.592 0.016,14.388 0.182,14.363 L13.650,12.409 C13.716,12.399 13.773,12.358 13.803,12.298 L19.826,0.110 C19.900,-0.041 20.115,-0.041 20.189,0.110 Z"
                />
            </svg>
        </div>

        <svg
            v-for="i in 5"
            :key="i"
            class="testimonials__star"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            viewBox="0 0 40 38"
        >
            <path
                d="M20.189,0.110 L26.212,12.298 C26.242,12.358 26.299,12.399 26.365,12.409 L39.832,14.363 C39.999,14.388 40.065,14.592 39.945,14.709 L30.200,24.196 C30.152,24.243 30.130,24.310 30.141,24.376 L32.442,37.772 C32.470,37.938 32.296,38.064 32.147,37.986 L20.102,31.661 C20.043,31.630 19.972,31.630 19.913,31.661 L7.867,37.986 C7.719,38.064 7.545,37.938 7.573,37.772 L9.874,24.376 C9.885,24.310 9.863,24.243 9.815,24.196 L0.070,14.709 C-0.050,14.592 0.016,14.388 0.182,14.363 L13.650,12.409 C13.716,12.399 13.773,12.358 13.803,12.298 L19.826,0.110 C19.900,-0.041 20.115,-0.041 20.189,0.110 Z"
            />
        </svg>
    </div>

</template>

<script>
export default {
    props: {
        stars: {
            type: Number,
            required: true,
        },
    },
};
</script>
